export enum Zone {
  Deck,
  Hand,
  Field,
  Graveyard,
}
